module.exports = __webpack_public_path__ + "static/media/blom-pysanky-thumb-60.bd67aa0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-thumb-60.jpg
// module id = 4019
// module chunks = 15